import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import InlineSplitTransaction from '@/components/InlineSplitTransaction.vue';
import exCreditCard from '@/mixins/exCreditCard';

const userExpensesMix = {
  mixins: [
    InlineSplitTransaction,
    exCreditCard,
  ],
  data() {
    return {
      dialogPdfVisible: false,
      selectAllTransactions: false,
      totalTransactionsOnScreen: [],
      totalTransactionFromApi: [],
      pageWiseSelectAllOptin: [],
      timer: null,
      timeoutVal: 1000,
      typer: null,
      showFilter: [
        'Date',
        'Team',
        'Category',
        'Tag',
        'Merchant',
        'Amount',
      ],
      inlineComponents: [InlineSplitTransaction],
      showTableColumn: [
        { label: 'Date', isShow: true },
        { label: 'Settlement Date', isShow: true },
        { label: 'Company', isShow: true },
        { label: 'Team', isShow: true },
        { label: 'Category', isShow: true },
        { label: 'Tag', isShow: true },
        { label: 'Employee', isShow: false },
        { label: 'Card', isShow: false },
        { label: 'Account', isShow: false },
        { label: 'Merchant', isShow: true },
        { label: 'Amount', isShow: true },
        { label: 'Split', isShow: true },
        { label: 'Transaction Notes', isShow: true },
        { label: 'Operations', isShow: true },
        { label: 'Receipt', isShow: true },
        { label: 'Status', isShow: true },
      ],
      checkedColumns: ['Date', 'Settlement Date', 'Company', 'Team', 'Category', 'Tag', 'Merchant', 'Amount', 'Split', 'Transaction Notes', 'Receipt', 'Operations', 'Status'],
      splitAmountVisible: false,
      splitData: {
        amount: 0,
        id: '',
      },
    };
  },

  created() {
    const seq1 = [];
    let seq = [...this.showTableColumn];
    let list = localStorage.getItem('transactionHeader');
    if (list === null || list === '') {
      seq = [...this.showTableColumn];
      seq.forEach((item) => {
        if (item.isShow) {
          seq1.push(item.label);
        }
      });
    } else {
      this.showTableColumn.forEach((item1) => {
        item1.isShow = false;
      });
      list = list.split(':');
      list.pop();
      list.reverse();
      if (list !== null) {
        seq.forEach((item) => {
          list.forEach((item1) => {
            if (item1.trim().toLowerCase() === item.label.trim().toLowerCase()) {
              item.isShow = true;
              seq1.push(item1.trim());
            }
          });
        });
      }
    }

    this.showTableColumn = [...seq];

    this.checkedColumns = [];
    this.checkedColumns = seq1;
    this.fnSetTableColumn(seq1);

    this.$nextTick(() => {
      this.typer = null;

      this.typer = document.getElementById('typer');
      if (this.typer) {
        this.typer.addEventListener('keydown', this.handleKeyPress);
        this.typer.addEventListener('keyup', this.handleKeyUp);
      }
    });
  },

  watch: {
  //  Default
  },

  methods: {

    ...mapActions('transactions', [
      'getUserSpentBudget',
      'getReceiptFromAWS',
      'getSingleUserExpense',
      'setInlineTransactions',
      'fnSetTableColumn',
      'removeMyTransaction',
      'receiptUpload',
      'storeColumnSelectionInTable',
      'filterTransactionsByMerchant',
      'cacheSelectedTransactions',
    ]),

    ...mapActions('receiptDownload', [
      'generatePdfTransactions',
      'downloadTransactionInPDF',
      'generateLinkAndDonwloadPdf',
      'removeDownloadedPdfLink',
    ]),

    modifyDateRange(dateRange) {
      console.log(dateRange);
      return dateRange.replace('TO', '<br>TO</br>');
    },
    handleRemovePdfFile(handleRemovePdfFileValue) {
      this.removeDownloadedPdfLink({ id: handleRemovePdfFileValue.id });
    },
    submitPDFName(submitPDFNameValue) {
      this.downloadTransactionsPdfEventHandler({ pdfName: submitPDFNameValue });
      this.dialogPdfVisible = false;
    },
    handleParentCloseForPDFDialog() {
      this.dialogPdfVisible = false;
    },
    handleKeyPress() {
      window.clearTimeout(this.timer);
    },
    fnDownloadGeneratedPDf(downloadGeneratedPDfValue) {
      this.generateLinkAndDonwloadPdf(downloadGeneratedPDfValue);
    },

    handleClickPdfDownload() {
      this.generatePdfTransactions({
        userId: this.me.id,
      });
    },
    showPDFNameDialog() {
      this.dialogPdfVisible = true;
    },

    downloadTransactionsPdfEventHandler(downloadTransactionsPdfEventHandlerValue) {
      // Inform to user first
      this.dialogPdfVisible = true;
      // get selected daterange
      const startDateTran = moment(this.startDate).format('YYYY-MM-DD');
      const endDateTran = moment(this.endDate).format('YYYY-MM-DD');
      const dateRange = `${startDateTran} TO ${endDateTran}`;
      const listTransactions = [];

      if (this.selectedTransactions.length) {
        // No transactions are selected
        this.selectedTransactions.forEach((transaction) => {
          listTransactions.push(transaction.id);
        });
      } else {
        // if transactions are not selected
        this.totalTransactionFromApi.forEach((transaction) => {
          listTransactions.push(transaction.id);
        });
      }

      if (listTransactions.length) {
        this.$message({
          message: 'Your PDF is being generated and will be available for download in the Transaction Audit menu.',
          type: 'info',
        });
      } else {
        this.$message({
          message: 'No transaction are to be download.',
          type: 'error',
        });
        return;
      }

      const transactionMetadata = {
        listTransactions,
        userId: this.me.id,
        dateRange,
        pdfName: downloadTransactionsPdfEventHandlerValue.pdfName,
      };
      const primaryData = {
        createdAt: new Date(),
        id: '',
        pdfLink: '',
        range: dateRange,
        status: 'Progress',
        user: { id: this.me.id },
      };

      if (this.generatePdfTransaction && this.generatePdfTransaction.length) {
        this.generatePdfTransaction.unshift(primaryData);
      }

      if (this.generatePdfTransaction.length > 5) {
        this.generatePdfTransaction.pop();
      }
      if (listTransactions.length) {
        this.downloadTransactionInPDF(transactionMetadata);
      }
      this.cacheSelectedTransactions([]);
    },

    handleKeyUp() {
      window.clearTimeout(this.timer); // prevent errant multiple timeouts from being generated
      this.timer = window.setTimeout(() => {
        this.filterTransactionsByMerchant(this.typer.value);
      }, this.timeoutVal);
    },

    handleCloseSplit() {
      this.initComp();
      this.splitAmountVisible = false;
    },

    handleParentSlowSplit(value) {
      this.splitData.amount = value.amount;
      this.splitData.id = value.expenseId;
      this.dialogFormVisible = false;
      this.splitAmountVisible = true;
    },

    handleCheckedColumnsChange(value) {
      this.showTableColumn.forEach((item1) => {
        item1.isShow = false;
      });

      value.forEach((item) => {
        this.showTableColumn.forEach((item1) => {
          if (item1.label === item) {
            item1.isShow = true;
          }
        });
      });
      // Save to local
      const tempSeq = [...this.showTableColumn];


      let list = '';
      tempSeq.forEach((item) => {
        if (item.isShow) {
          list = `${item.label}: ${list}`;
        }
      });

      localStorage.setItem('transactionHeader', list);
      if (this.me) {
        this.storeColumnSelectionInTable({
          id: this.me.currentCompUserSettings[0].id,
          transactionScreenColumnSelection: list,
        });
      }
      this.fnSetTableColumn(value);
    },

    async showMySplitedTransactions(value) {
      await this.getSingleUserExpense({ id: value.id });
      let data = this.singleTransactions;
      if (data.splitTransactions.length) {
        await this.getSingleUserExpense({ id: data.splitTransactions[0].note });
        data = this.singleTransactions;
      }
      let splitTransactions = [];
      if (!data.splitTransactions.length) {
        const isMainTransaction = (data.marqetaTransactionId === null || data.marqetaTransactionId === '') && (data.ccTransactionId === null || data.ccTransactionId === '');
        splitTransactions = [{
          id: data.id,
          selectedCompany: data.Company.id,
          selectedCompanyName: data.Company.companyName,
          teamId: data.group ? data.group.id : '',
          categoryId: data.category ? data.category.id : '',
          month: data.month,
          year: data.year,
          expenseDate: data.expenseDate,
          amount: Number(data.amount),
          isMainTransaction,
        }];
        value.splitId = '';
        value.originalAmount = data.amount;
        value.originalId = data.id;
      } else {
        if (data.splitTransactions.length) {
          value.splitId = data.splitTransactions[0].id;
          value.originalAmount = data.splitTransactions[0].amount;
          value.originalId = data.splitTransactions[0].note;
        }
        data.splitTransactions[0].UserExpense.forEach((t) => {
          const isMainTransaction = (t.marqetaTransactionId === null || t.marqetaTransactionId === '') && (t.ccTransactionId !== null || t.ccTransactionId === '');
          splitTransactions.push(
            {
              id: t.id,
              selectedCompany: t.Company.id,
              selectedCompanyName: t.Company.companyName,
              teamId: t.group ? t.group.id : null,
              categoryId: t.category ? t.category.id : null,
              month: data.month,
              year: data.year,
              expenseDate: data.expenseDate,
              amount: t.amount,
              isMainTransaction,
              accountingTransaction: t.accountingTransaction,
              agillinkTransaction: t.agillinkTransaction,
            },
          );
        });
      }
      this.setInlineTransactions(splitTransactions);
    },
    submitReceipt(value) {
      const {
        userId,
        categoryId,
        groupId,
        expenseId,
        qbSyncStatus,
        qbSyncId,
        uploadedReceipts,
        deleteReceipt,
        selectedCompany,
        originCompany,
        description,
        tagId,
        tagAction,
        prevTag,
        splitMyTransaction,
        deleteMySplitTransactions,
        triggerAt,
      } = value;

      this.receiptUpload({
        reciepts: uploadedReceipts,
        id: expenseId,
        qbSyncStatus,
        qbSyncId,
        description,
        userId,
        categoryId,
        groupId,
        expenseReceiptsTodelete: deleteReceipt,
        selectedCompany,
        originCompany,
        tagId,
        tagAction,
        prevTag,
        splitMyTransaction,
        deleteMySplitTransactions,
        value: value.value,
        triggerAt,
      });
    },
    getShowReceipt(value) {
      if (value.splitTransactions.length) {
        if (value.splitTransactions[0].UserExpense.length) {
          if (value.splitTransactions[0].UserExpense[0].expenseReceipts.length) {
            return true;
          }
        }
      }
      return false;
    },

    sortTable(type, col) {
      this.filterType = type;
      this.filter = col;
      this.getTableData();
    },

    openactivename(value) {
      this.showSpit(value);
    },
    async showSpit(row) {
      this.$emit('deleteSplit');
      await this.showMySplitedTransactions(row);
      this.removeMyTransaction([]);

      this.makeSplit = false;
      // Entry Validate calculaton;
      this.validateTotalAmount();


      if (this.inlineComponents.length > 1) {
        this.inlineComponents.push(InlineSplitTransaction);
      } else if (this.myInlineTransaction) {
        this.inlineComponents = [];
        if (this.myInlineTransaction.length > 1) {
          this.myInlineTransaction.forEach(() => {
            this.makeSplit = true;
            this.inlineComponents.push(InlineSplitTransaction);
          });
        }
      }
    },
    transactionSelectionState(event, transactionObj) {
      if (event) {
        this.selectedTransactions.push({
          id: transactionObj.id,
          instrumentType: transactionObj.instrumentType,
          accountingSynchedData: this.getAccountingSynchedData(transactionObj),
          transactionTagId: (transactionObj.TransacisonsTag.length > 0) ? transactionObj.TransacisonsTag[0].id : null,
          amount: transactionObj.amount,
          teamId: (transactionObj.group) ? transactionObj.group.id : null,
        });
        this.cacheSelectedTransactions(this.selectedTransactions);
      } else {
        const tranObjIndex = this.selectedTransactions.findIndex(transaction => transaction.id === transactionObj.id);
        if (tranObjIndex >= 0) {
          this.selectedTransactions.splice(tranObjIndex, 1);
          this.cacheSelectedTransactions(this.selectedTransactions);
        }
      }
    },
    // Returns transaction meta data related to synching status with accounting systems.
    getAccountingSynchedData(transactionObj) {
      const { activeAccountingSys } = this;
      const synchedData = {
        status: 'not_synched',
        isAgilLink: false,
        accountingTransationId: null,
      };
      if (transactionObj.accountingTransaction && transactionObj.accountingTransaction.qbSyncStatus === 1) {
        // Case of QuickBooks and Xero
        if (activeAccountingSys && activeAccountingSys.getActiveAccountingSystem.activeAccSys === transactionObj.accountingTransaction.accSysName) {
          synchedData.status = 'synched';
          synchedData.accountingTransationId = transactionObj.accountingTransaction.id;
        }
      }
      if (transactionObj.agillinkTransaction && transactionObj.agillinkTransaction.alSyncStatus === 1) {
        // Case of AgilLink
        if (activeAccountingSys && activeAccountingSys.getActiveAccountingSystem.activeAccSys === 'AGILLINK') {
          synchedData.status = 'synched';
          synchedData.isAgilLink = true;
          synchedData.accountingTransationId = transactionObj.agillinkTransaction.id;
        }
      }
      return synchedData;
    },
    tableColumnResize() {
      this.table = document.querySelectorAll('.myTable')[this.setTabName];

      const row = this.table.getElementsByTagName('tr')[0];
      const cols = row ? row.children : undefined;
      if (!cols) {
        return;
      }

      for (const element of cols) {
        const thElement = element;
        const thSelectorElement = thElement.querySelectorAll('.columnSelector');

        if (thSelectorElement.length === 0) {
          const div = this.createDiv();
          element.appendChild(div);
          element.style.position = 'relative';

          this.setListener(div);
        }
      }
    },
    setListener(div) {
      let pageX; let currentColumn; let curColWidth;

      div.addEventListener('mouseout', (e) => {
        const element = e.target.parentElement;

        if (element.nodeName === 'B') {
          currentColumn = e.target.parentElement.parentElement.parentElement;
        }
        if (element.nodeName === 'DIV') {
          currentColumn = e.target.parentElement.parentElement;
        }
        // Grab 'columnSelector'
        if (currentColumn) {
          let thSelectorElement = currentColumn.querySelectorAll('.columnSelector');
          if (thSelectorElement.length) {
            thSelectorElement[0].style.width = '1px';
          } else {
            currentColumn = e.target.parentElement.parentElement;
            thSelectorElement = currentColumn.querySelectorAll('.columnSelector');
            if (thSelectorElement.length) {
              thSelectorElement[0].style.width = '1px';
            }
          }
        }
      });
      div.addEventListener('mouseover', (e) => {
        const element = e.target.parentElement;

        if (element.nodeName === 'B') {
          currentColumn = e.target.parentElement.parentElement.parentElement;
        }
        if (element.nodeName === 'SVG') {
          currentColumn = e.target.parentElement.parentElement.parentElement;
          console.log(currentColumn);
        }
        if (element.nodeName === 'DIV') {
          currentColumn = e.target.parentElement.parentElement;
        }
        // Grab 'columnSelector'
        if (currentColumn) {
          let thSelectorElement = currentColumn.querySelectorAll('.columnSelector');
          if (thSelectorElement.length) {
            thSelectorElement[0].style.width = '10px';
          } else {
            currentColumn = e.target.parentElement.parentElement;
            thSelectorElement = currentColumn.querySelectorAll('.columnSelector');
            if (thSelectorElement.length) {
              thSelectorElement[0].style.width = '10px';
            }
          }
        }
      });
      div.addEventListener('mousedown', (e) => {
        const element = e.target.parentElement;

        if (element.nodeName === 'B') {
          currentColumn = e.target.parentElement.parentElement.parentElement;
        }
        if (element.nodeName === 'DIV') {
          currentColumn = e.target.parentElement.parentElement;
        }

        if (element.nodeName === 'SVG') {
          currentColumn = e.target.parentElement.parentElement.parentElement;
        }

        // Grab 'columnSelector'
        if (currentColumn) {
          let thSelectorElement = currentColumn.querySelectorAll('.columnSelector');
          if (thSelectorElement.length) {
            thSelectorElement[0].style.width = '10px';
          } else {
            currentColumn = e.target.parentElement.parentElement;
            thSelectorElement = currentColumn.querySelectorAll('.columnSelector');
            if (thSelectorElement.length) {
              thSelectorElement[0].style.width = '10px';
            }
          }
        }

        // eslint-disable-next-line prefer-destructuring
        pageX = e.pageX;
        curColWidth = currentColumn.offsetWidth;
      });
      document.addEventListener('mousemove', (e) => {
        if (currentColumn) {
          const diffX = e.pageX - pageX;
          currentColumn.style.width = `${curColWidth + diffX}px`;
        }
      });
      document.addEventListener('mouseup', () => {
        currentColumn = undefined;
        pageX = undefined;
        curColWidth = undefined;
      });
    },
    createDiv() {
      const div = document.createElement('div');
      div.style.top = 0;
      div.style.right = 0;
      div.style.width = '1px';
      div.style.position = 'absolute';
      div.style.cursor = 'grabbing';
      div.style.backgroundColor = '#6e966a';
      div.style.color = '#FFF';
      div.style.userSelect = 'none';
      div.style.height = '25px';
      div.className = 'columnSelector';
      div.innerHTML = '<b> <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="bars" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="fs-18 svg-inline--fa fa-bars fa-w-14"><path fill="currentColor" d="M442 114H6a6 6 0 0 1-6-6V84a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6z" class=""></path></svg></b>';
      return div;
    },
    isTransactionSynched(transactionObj) {
      let isSynched = false;
      if (transactionObj.accountingTransaction
        && (transactionObj.accountingTransaction.qbSyncStatus === 1 || transactionObj.accountingTransaction.qbSyncStatus === 2)) {
        isSynched = true;
      }

      if (transactionObj.agillinkTransaction
        && (transactionObj.accountingTransaction.qbSyncStatus === 1 || transactionObj.accountingTransaction.qbSyncStatus === 2)) {
        isSynched = true;
      }
      return isSynched;
    },
    // Mark/Unmark select all checkbox
    selectAllTransactionToggleOperation(event) {
      if (event) {
        this.pageWiseSelectAllOptin.push(this.tableCurrentPage);
      } else {
        const index = this.pageWiseSelectAllOptin.indexOf(this.tableCurrentPage);
        if (index >= 0) {
          this.pageWiseSelectAllOptin.splice(index, 1);
        }
      }

      for (const transaction of this.totalTransactionsOnScreen) {
        // Following code removed as we are nowable to
        // const isSynched = this.isTransactionSynched(transaction);
        // if (!isSynched) {
        // set value for Bulk categorize button badge.
        if (!(event && transaction.isSelected)) {
          this.transactionSelectionState(event, transaction);
        }
        // set value for v-model of checkbox
        transaction.isSelected = event;
        // }
      }
    },
    unSelectAllTransactions() {
      this.selectAllTransactions = false;
      this.pageWiseSelectAllOptin = [];
      this.selectAllTransactionToggleOperation(false);
      for (const transaction of this.totalTransactionFromApi) {
        const isSynched = this.isTransactionSynched(transaction);
        if (!isSynched) {
          this.transactionSelectionState(false, transaction);
          // set value for v-model of checkbox
          transaction.isSelected = false;
        }
      }
    },
  },
  computed: {
    ...mapGetters('transactions', ['singleTransactions', 'deletedTrans', 'myInlineTransaction', 'selectedTransactions', 'setTabName']),
    ...mapGetters('accounting', ['activeAccountingSys']),
    ...mapGetters('receiptDownload', ['generatePdfTransaction', 'removedPdfLink']),
  },

};

export default userExpensesMix;
